<script>
  export let size = 28;
</script>

<svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M21.7221 5.84736L21.569 5.71776L21.4399 5.87121L11.9019 17.2032L7.24786 13.3204L7.09587 13.1936L6.9675 13.3442L5.34776 15.2453L5.21697 15.3988L5.37156 15.5283L12.0856 21.1533L12.2385 21.2813L12.367 21.1289L23.6529 7.7435L23.7816 7.59091L23.6292 7.46194L21.7221 5.84736Z"
    fill="white"
    stroke="white"
    stroke-width="0.4"
  />
</svg>
